import { MilestoneTypeEnum } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function milestoneTypeOptions(): SelectOption<string>[] {
  return [
    MilestoneTypeEnum.pickup,
    MilestoneTypeEnum.packing,
    MilestoneTypeEnum.vanning,
    MilestoneTypeEnum.custom_clearance,
    MilestoneTypeEnum.cy_cfs_cut,
    MilestoneTypeEnum.air_transportation,
    MilestoneTypeEnum.sea_transportation,
    MilestoneTypeEnum.devanning,
    MilestoneTypeEnum.delivery,
    MilestoneTypeEnum.free_text
  ].map((val: MilestoneTypeEnum) => {
    return { value: val, label: i18n.t(`milestoneType.${val}`).toString() };
  });
}
